import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anonymous, object = authenticated

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        // Returning from OAuth callback: AuthCallback establishes the session first.
        if (window.location.hash?.includes("session_id=")) {
            setUser(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } finally {
            setUser(false);
        }
    }, []);

    return <AuthCtx.Provider value={{ user, setUser, logout, checkAuth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const isStaff = (u) => u && ["moderator", "editor", "admin", "super_admin"].includes(u.role);
export const isAdmin = (u) => u && ["admin", "super_admin"].includes(u.role);
